import React, { useReducer, useContext, useState, useEffect, useRef } from "react";
import filterReducer from "../../../context/filterReducer";
import StickyHeader from "../../../context/stickyheaderContext";






export const FilterParentContainer = ({children, sticky, className, ...rest }) => {
    const initialState = {
        isStickyHeader: false
    }

    const rootMargin = '-72px 0px 0px 0px';
    const rootMarginMobile = '-86px 0px 0px 0px';


  
    const [state, dispatch] = useReducer(filterReducer, initialState);
    const [isSticky, setIsSticky] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth);
    
    const ref = useRef();
    
    // mount 
    useEffect(()=>{

      window.addEventListener('resize', setIsMobile(window.innerWidth));
      const cachedRef = ref.current,
            observer = new IntersectionObserver(
              // ([e]) => {;


              ([e]) => { e.isIntersecting < 1 ? dispatch({ type: 'SET_STICKY_HEADER', payload: true}) : dispatch({ type: 'SET_STICKY_HEADER', payload: false});
              setIsSticky(e.intersectionRatio < 1)
        },
              {threshold: [1],
                rootMargin: isMobile ? rootMarginMobile : rootMargin
             }
            )
      
      observer.observe(cachedRef)
      
      // unmount
      return function(){
        observer.unobserve(cachedRef)
      }
    }, [isSticky, isMobile]);

    
    
    return (
        <StickyHeader.Provider value={{
            isStickyHeader: state.isStickyHeader
          }}>
            <div  className={'filter-parent-container' + (isSticky ? " isSticky" : "")} ref={ref} {...rest}>
        {children}
            </div>
          </StickyHeader.Provider>
      
    )
  }